.o-text-introduction{margin-bottom:60px;margin-top:0}.o-text-introduction>*{margin-bottom:15px;margin-top:0;max-width:41.875rem}